import React from "react";
import { Loadable, IRouteItem } from "@techzyapp/ui-lib";
import { SET_PASSWORD_PATH } from "utils/constants/paths";

const SetPassword = Loadable(React.lazy(() => import("./View")));

export const SetPasswordRoute: IRouteItem = {
  path: SET_PASSWORD_PATH,
  iconName: "",
  element: React.createElement(SetPassword),
  showInDrawer: false,
};
